import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { WarehouseReleaseCollectionItem } from '../../models/warehouse-release-collection-item';
import { WarehouseReleaseCollectionFilter } from '../../models/warehouse-release-collection-filter';
import { WarehouseReleaseStatusComponent } from '../warehouse-release-status/warehouse-release-status.component';

@Component({
  selector: 'app-warehouse-release-list-custom-cell-template',
  imports: [TableBodyNoReferenceCellComponent, WarehouseReleaseStatusComponent],
  templateUrl: './warehouse-release-list-custom-cell-template.component.html',
  styleUrl: './warehouse-release-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReleaseListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<WarehouseReleaseCollectionItem, WarehouseReleaseCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<WarehouseReleaseCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<WarehouseReleaseCollectionItem>;
}
